// Kiosk Adisyon Yazdırma Ayarları penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.kioskReceiptSettings';

export const kioskReceiptSettingsGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Kiosk adisyon (fiş) ayarları nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Bu pencere, kiosktan verilen siparişlerde yazdırılan fişin/adisyonun başlığını, içeriğini ve kâğıt biçimini belirler. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Fiş ayarları'),
    footer: t(`${G}.regions.footer`, 'İptal / Kaydet'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Fiş başlığını seçin'),
      text: t(`${G}.s1.text`, '"Metin Başlık (Şirket Bilgileri)" seçilirse fişin üstüne Şirket Adı, VKN, Mersis, telefon, web sitesi ve adres yazılır; bu tipte Şirket Adı zorunludur. "Logo Başlık" seçilirse logo yüklemek zorunludur.'),
      tips: [
        t(`${G}.s1.tip1`, 'Logo en fazla 5 MB, JPG/PNG resim olmalıdır. "Logoyu Sil" ile kaldırabilirsiniz.'),
        t(`${G}.s1.tip2`, '"Fiş başlık metni/logosu göster" kapalıysa başlık fişte yazdırılmaz.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Yazdırma ayarları'),
      text: t(`${G}.s2.text`, '"Ara Toplam ve KDV Toplam göster" ile fişte ara toplam ve KDV satırlarını açıp kapatırsınız. Kopya sayısı 1–9 arasıdır; boş bırakılırsa 1 adet yazdırılır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Alt bilgi'),
      text: t(`${G}.s3.text`, '"Fiş Altında Gösterilecek Standart Not" ve "Teşekkür Mesajı/Slogan" fişin en altına yazılır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Fiş formatı'),
      text: t(`${G}.s4.text`, 'Fiş genişliğini (mm), satır başına karakter sayısını ve üst / alt / sol / sağ kenar boşluklarını (mm) yazıcınızın kâğıdına göre girin.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kaydet ve ana kaydı unutmayın'),
      text: t(`${G}.s5.text`, '"Kaydet" ayarları Kiosk Ayarları penceresine aktarır ve bu pencereyi kapatır. Kalıcı olması için Kiosk Ayarları penceresinin altındaki "Değişiklikleri Kaydet" düğmesine de basın.'),
    },
  ],
});
